import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseText, BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { useUserStore } from '@/store/useUserStore'
import { responsiveAdapterVertical } from '@/utils/responsive'
import { useTheme } from '@/hooks/useTheme'
import { AppIcons } from '@/components/AppIcons'
import { AppButton } from '@/components'
import { useDeviceShare } from '@/hooks'
import { useGetMessageAndLinkToShareMyProfileWithReferralCode } from '@/hooks/useGetMessageAndLinkToShareMyProfile'

export const InviteFriendsScreen: React.FC = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const { t } = useTranslation()
  const userAuthenticated = useUserStore((s) => s.userAuthenticated)
  const referralCode = userAuthenticated?.referral.code
  const { share, copy } = useDeviceShare()
  const { message } = useGetMessageAndLinkToShareMyProfileWithReferralCode({
    referralCode: referralCode || '',
  })

  const handleUploadShare = () => {
    share({ title: ' ', message: message })
  }
  const handleCopyReferralCode = () => {
    copy(referralCode || '', t('translation:linkCopied'))
  }

  return (
    <BaseSafeFormView
      style={{}}
      flex={1}
      bgColor="background.screen"
      className="h-full"
    >
      <StickyHeaderNavigation onBackPress={() => navigate(-1)} />

      <BaseView
        style={{
          flex: 1,
          overflowY: 'auto',
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 13,
          paddingRight: 13,
        }}
        gap={32}
      >
        <BaseText
          fontSize={32}
          fontFamily="semibold"
          className="text-left mt-48 ml-4"
          style={{
            background:
              'linear-gradient(213deg, #FFFEE9 10.09%, #FACB40 38.5%, #FF9433 88.08%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontFeatureSettings: 'liga off, clig off',
          }}
        >
          {t('translation:inviteFriend.getPaidToInvite')}
          <span style={{ WebkitTextFillColor: 'white' }}> 👑</span>
        </BaseText>
        <BaseView gap={32} className="items-start justify-start relative ml-4">
          <div className="absolute left-4 top-0 h-full w-[1px] bg-white/10  -translate-x-1/2"></div>
          <BaseView
            row
            gap={16}
            className="items-center justify-start shrink-0 relative "
          >
            <BaseView circleSize={8} className="shrink-0 w-8 h-8 static">
              <BaseView
                circleSize={8}
                className="w-8 h-8 static"
                style={{ aspectRatio: 1 }}
              >
                <BaseView
                  circleSize={8}
                  className="rounded-[50%] w-8 h-8 absolute left-0 top-0"
                  style={{
                    background:
                      'linear-gradient(202deg, #FCFBE7 -151.17%, #FFD475 -13.73%, #DD8536 64.45%)',
                  }}
                ></BaseView>
              </BaseView>
              <BaseText
                fontSize={20}
                fontFamily="semibold"
                className="absolute left-[9px] top-2 w-[13px] h-[15px] flex items-center justify-center"
                style={{
                  letterSpacing:
                    'var(--headline-3semibold20pt-letter-spacing, 0.0129em)',
                }}
              >
                1
              </BaseText>
            </BaseView>
            <BaseText
              fontSize={18}
              fontFamily="semibold"
              className="text-[#ffffff] text-left relative flex items-center justify-start"
              style={{
                letterSpacing:
                  'var(--headline-6semibold18pt-letter-spacing, 0.0129em)',
              }}
            >
              {t('translation:inviteFriend.shareYourCode')}
            </BaseText>
          </BaseView>
          <BaseView
            row
            gap={16}
            className="items-center justify-start shrink-0 relative "
          >
            <BaseView circleSize={8} className="shrink-0 w-8 h-8 static">
              <BaseView
                circleSize={8}
                className="w-8 h-8 static"
                style={{ aspectRatio: 1 }}
              >
                <BaseView
                  circleSize={8}
                  className="rounded-[50%] w-8 h-8 absolute left-0 top-0"
                  style={{
                    background:
                      'linear-gradient(202deg, #FCFBE7 -151.17%, #FFD475 -13.73%, #DD8536 64.45%)',
                  }}
                ></BaseView>
              </BaseView>
              <BaseText
                fontSize={20}
                fontFamily="semibold"
                className="absolute left-[9px] top-2 w-[13px] h-[15px] flex items-center justify-center"
                style={{
                  letterSpacing:
                    'var(--headline-3semibold20pt-letter-spacing, 0.0129em)',
                }}
              >
                2
              </BaseText>
            </BaseView>
            <BaseText
              fontSize={18}
              fontFamily="semibold"
              className="text-[#ffffff] text-left relative flex items-center justify-start"
              style={{
                letterSpacing:
                  'var(--headline-6semibold18pt-letter-spacing, 0.0129em)',
              }}
            >
              {t('translation:inviteFriend.theySignUpAndEnterYourCode')}
            </BaseText>
          </BaseView>
          <BaseView
            row
            gap={16}
            className="items-center justify-start shrink-0 relative "
          >
            <BaseView
              circleSize={8}
              className="shrink-0 w-8 h-8 self-end relative"
            >
              <BaseView
                circleSize={8}
                className="w-8 h-8 relative"
                style={{ aspectRatio: 1 }}
              >
                <BaseView
                  circleSize={8}
                  className="rounded-[50%] w-8 h-8 relative left-0 top-0"
                  style={{
                    background:
                      'linear-gradient(202deg, #FCFBE7 -151.17%, #FFD475 -13.73%, #DD8536 64.45%)',
                  }}
                ></BaseView>
              </BaseView>
              <BaseText
                fontSize={20}
                fontFamily="semibold"
                className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-[13px] h-[15px] flex items-center justify-center"
                style={{
                  letterSpacing:
                    'var(--headline-3semibold20pt-letter-spacing, 0.0129em)',
                }}
              >
                3
              </BaseText>
            </BaseView>
            <BaseText
              fontSize={18}
              fontFamily="semibold"
              className="text-[#ffffff] text-left relative flex items-center justify-start"
              style={{
                letterSpacing:
                  'var(--headline-6semibold18pt-letter-spacing, 0.0129em)',
              }}
            >
              {t('translation:inviteFriend.youBothGetRewarded')}&nbsp;
              <span
                style={{
                  background:
                    'linear-gradient(213deg, #FFFEE9 10.09%, #FACB40 38.5%, #FF9433 88.08%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontFeatureSettings: 'liga off, clig off',
                }}
              >
                {t('translation:inviteFriend.rewardSubject')}
              </span>
            </BaseText>
          </BaseView>
        </BaseView>
        <BaseView
          style={{
            marginTop: responsiveAdapterVertical(38),
            borderWidth: 1,
            borderColor: '#D8B35D',
          }}
          rounded={20}
          p={17}
          h={54}
          row
          gap={15}
          align="center"
          justify="flex-start"
        >
          <BaseText fontSize={16} fontFamily="semibold">
            {t('translation:shareCode')}:
          </BaseText>
          <BaseText fontSize={16} fontFamily="semibold">
            {referralCode}
          </BaseText>
          <div
            className="ml-auto"
            onClick={() => {
              handleCopyReferralCode()
            }}
          >
            <AppIcons
              name="copyFilled"
              size={24}
              color={theme.colors.icon.primary}
            />
          </div>
        </BaseView>
        <BaseView
          // style={{
          //   marginTop: responsiveAdapterVertical(40),
          // }}
          row
          gap={8}
        >
          <BaseView circleSize={20}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0013 18.3334C5.39893 18.3334 1.66797 14.6024 1.66797 10C1.66797 5.39765 5.39893 1.66669 10.0013 1.66669C14.6036 1.66669 18.3346 5.39765 18.3346 10C18.3346 14.6024 14.6036 18.3334 10.0013 18.3334ZM10.0013 16.6667C13.6832 16.6667 16.668 13.6819 16.668 10C16.668 6.31812 13.6832 3.33335 10.0013 3.33335C6.3194 3.33335 3.33464 6.31812 3.33464 10C3.33464 13.6819 6.3194 16.6667 10.0013 16.6667ZM9.16797 6.66669C9.16797 6.20645 9.54107 5.83335 10.0013 5.83335C10.4615 5.83335 10.8346 6.20645 10.8346 6.66669C10.8346 7.12692 10.4615 7.50002 10.0013 7.50002C9.54107 7.50002 9.16797 7.12692 9.16797 6.66669ZM9.16797 10C9.16797 9.53978 9.54107 9.16669 10.0013 9.16669C10.4615 9.16669 10.8346 9.53978 10.8346 10V13.3334C10.8346 13.7936 10.4615 14.1667 10.0013 14.1667C9.54107 14.1667 9.16797 13.7936 9.16797 13.3334V10Z"
                fill="#84878C"
              />
            </svg>
          </BaseView>
          <BaseText
            fontSize={12}
            lineHeight={16}
            fontFamily="regular"
            color="#84878C"
          >
            {t(
              'translation:inviteFriend.youAreEligibleToReceiveAReferralReward',
            )}{' '}
            <a
              className="text-white underline font-semibold"
              target="_blank"
              rel="noreferrer"
              href="https://kemapp.io/policies/referral-policy"
            >
              {t('links:referralPolicy')}
            </a>
            .
          </BaseText>
        </BaseView>
        <AppButton
          type="primaryGradient"
          label={t('translation:shareCode')}
          onPress={() => {
            handleUploadShare()
          }}
          style={{
            background:
              'linear-gradient(202deg, #FCFBE7 -151.17%, #FFD475 -13.73%, #DD8536 64.45%)',
          }}
        />
      </BaseView>
    </BaseSafeFormView>
  )
}
